import info from "./information.png";
import { EmployeesList } from "./EmployeesList/EmployeesList";

import EmployeesListContext from "./EmployeesListContext/EmployeesListContext";

import { EmployeesListFiltered } from "./EmployeesListFiltered/EmployeesListFiltered";

import CustomLoader from "../../../../../common/CustomLoader/CustomLoader";


import {
    getStructureTopThunkAction,
} from "../../../../../../redux/actions/Requests/LeaderRequests/thunk/getStructureTop.thunk.action";
import {
    getUserRequestsThunkAction,
} from "../../../../../../redux/actions/Requests/GetUserRequests/thunk/getUserRequests.thunk.action";


import RequestServices from "../../../../../../frontend.services/RequestServices/RequestServices";

import React, { useContext, useEffect, useState } from "react";
import "./RecruitmentToWorkOnHolidaysModal.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";


const RecruitmentToWorkOnHolidaysContent = ({
    close,
    setStageModalWindow,
    testHOC,
    setSelectedE,
    selectedE,
}) => {

    const dispatch = useDispatch();
    const requestCard = useSelector((state) => state.requests?.singleDocument?.currentRequest);
    const requests = useSelector((state) => state.requests);
    console.log(requestCard);

    const [step, setStep] = useState(0);
    // const [selectedE, setSelectedE] = useState([]);
    const { employeesSelected, clearSelectedToggle } = useContext(EmployeesListContext);

    function getColorForStatus() {
        if(requestCard.status === 24) {
            return "green";
        } else if(requestCard.status === 32) {
            return "green";
        }
        else if(requestCard.status === 30 || requestCard.status > 32) {
            return "red";
        }
        return "";
    }

    function getSortedEmployees(araayForSort) {
        let sortedArray;
        let result = [];
        if(araayForSort) {

            result = araayForSort.sort((a,b) =>a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase(), "ru"));
            if(step === 1 ) {
                return result;
            }
            // result = sortedArray.sort((a) => {
            //     if (a.agreement.status === 4) {
            //         return -1;
            //     }
            //     if (a.agreement.status > 4) {
            //         return 1;
            //     }
            //     return 0;
            // });



            const firstArray = araayForSort.filter(el => el.agreement.status === 4 ).sort((a,b) =>a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase(), "ru"));
            const secondArray = araayForSort.filter(el => el.agreement.status < 4).sort((a,b) => a.status + b.status).sort((a,b) =>a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase(), "ru"));
            const thirdArray = araayForSort.filter(el => el.agreement.status > 4).sort((a,b) => a.agreement.status - b.agreement.status).sort((a,b) =>a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase(), "ru"));
            result = [...firstArray, ...secondArray, ...thirdArray];
        }


        return result;
    }

    useEffect(() => {

        // console.log("requestCard", employeesSelected.size);
    }, [employeesSelected]);


    useEffect(() => {
        return () => {
            clearSelectedToggle();
            // setSelectedE([]);
            // dispatch(getStructureTopThunkAction());
            // dispatch(
            //     getUserRequestsThunkAction({
            //         page: {
            //             pageSize: requests?.userRequests?.pageSize,
            //             pageNumber: requests?.userRequests?.pageNumber,
            //         },
            //     }),
            // );
            // dispatch(unsetCurrentDocumentAction());
        };
    }, []);
    return (
        <div className=" request-modal-woh">
            {
                !requestCard ? <CustomLoader /> :
                    <>

                        {/*<div className="request-modal__header">*/}
                        {/*    <span> {requestCard.memo ? "Служебная записка" : "Заявка"} {requestCard && requestCard.number && requestCard.number} Работа в выходной, праздничный день</span>*/}
                        {/*</div>*/}
                        <div className="request-modal__table">
                            <div className="request-modal__table__line">
                                <div className="left-column">
                                    Инициатор заявки
                                </div>
                                <div
                                    className="right-column">{requestCard.initiator.fullName}
                                    { requestCard.delegatePid ?
                                        <div style={{ margin: "10px 0 0 0 " }}
                                            className="table-container__delegation-legend ">
                                            <div className="table-container__delegation-legend__color-item"></div>
                                            <div>Делегированная заявка
                                            </div>
                                        </div>
                                        : null}

                                    {/*— {requestCard.initiator.jobTitle}*/}
                                </div>
                            </div>
                            <div className="request-modal__table__line">
                                <div className="left-column">дата подачи</div>
                                <div
                                    className="right-column">{moment(requestCard.createdAtUtc).format("DD.MM.YYYY")}</div>
                            </div>
                            <div className="request-modal__table__line">
                                <div className="left-column">Статус заявки</div>
                                <div className={"right-column"}>
                                    <span className={getColorForStatus()}>
                                        {requestCard.statusName}
                                    </span>

                                </div>
                            </div>
                            <div className="request-modal__table__line">
                                <div className="left-column">Расшифровка причины привлечения к работе в выходные,
                                    праздничные
                                    дни
                                </div>
                                <div className="right-column">{requestCard.reason}</div>
                            </div>
                            {requestCard && requestCard.memo && requestCard.memo.approvers.length ?
                                <div className="request-modal__table__line">
                                    <div className="left-column">
                                    согласующие/
                                    дата поступления
                                    </div>
                                    <div className="right-column">
                                        { requestCard.memo.approvers.map((approver, index) => {
                                            return(
                                                <div key={index} className={"recrutment-approvers"}>
                                                    <div
                                                        className={
                                                            (approver.status === 1 || requestCard.status > 28 ) ? "recrutment-approvers__passive" :
                                                                (requestCard.memo.approvers[index + 1]
                                                                    ? requestCard.memo.approvers[index + 1].assignedAt
                                                                        ? "recrutment-approvers__passive"
                                                                        : "recrutment-approvers__active"
                                                                    : approver.assignedAt
                                                                        ? "recrutment-approvers__active"
                                                                        : "recrutment-approvers__normal")
                                                        }>
                                                        {approver.name}
                                                    </div>
                                                    <div
                                                        style={approver.status > 3 ?{color: "red"} : null}
                                                        className={
                                                            (approver.status === 1 || requestCard.status > 28 ) ? "recrutment-approvers__passive" :
                                                                (requestCard.memo.approvers[index + 1]
                                                                    ? requestCard.memo.approvers[index + 1].assignedAt
                                                                        ? "recrutment-approvers__passive"
                                                                        : "recrutment-approvers__active"
                                                                    : approver.assignedAt
                                                                        ? "recrutment-approvers__active"
                                                                        : "recrutment-approvers__normal")
                                                        }>
                                                        {approver.statusName}
                                                        { approver.statusNote ?
                                                            <span>
                                                                <img src={info} alt="#" />
                                                                <div className="custom-uploader__item__name__label">
                                                                    {approver.statusNote}
                                                                </div>
                                                            </span>
                                                            : null
                                                        }
                                                    </div>
                                                    <div
                                                        className={
                                                            (approver.status === 1 || requestCard.status > 28 ) ? "recrutment-approvers__passive" :
                                                                (requestCard.memo.approvers[index + 1]
                                                                    ? requestCard.memo.approvers[index + 1].assignedAt
                                                                        ? "recrutment-approvers__passive"
                                                                        : "recrutment-approvers__active"
                                                                    : approver.assignedAt
                                                                        ? "recrutment-approvers__active"
                                                                        : "recrutment-approvers__normal")
                                                        }>
                                                        {
                                                            approver.resolvedAt ? moment(approver.resolvedAt).format("DD.MM.YYYY")  : moment( approver.assignedAt).format("DD.MM.YYYY")
                                                        }
                                                    </div>
                                                    {/*{ approver.statusNote ?*/}
                                                    {/*    <span>*/}
                                                    {/*        <img src={info} alt="#" />*/}
                                                    {/*        <div className="custom-uploader__item__name__label">*/}
                                                    {/*            {approver.statusNote}*/}
                                                    {/*        </div>*/}
                                                    {/*    </span>*/}
                                                    {/*    : null*/}
                                                    {/*}*/}

                                                </div>
                                            );
                                        }) }
                                    </div>
                                </div>: null
                            }
                            <div className="employees-list-items">
                                {step === 1 || requestCard.memo
                                    ? <EmployeesListFiltered

                                        employees={requestCard && (requestCard.memo ? getSortedEmployees(requestCard?.memo?.employees && requestCard.memo?.employees)  : getSortedEmployees(requestCard?.employees).filter((i) =>
                                            employeesSelected.has(i.agreement.uid) && employeesSelected.get(i.agreement.uid)))}
                                    />
                                    : <EmployeesList
                                        selectedE={selectedE}
                                        setSelectedE={setSelectedE}
                                        employees={getSortedEmployees(requestCard && requestCard.employees && requestCard.employees)} />
                                }
                            </div>

                            {requestCard.memo && (
                                <div className="request-modal__table__line">
                                    <div className="left-column">Служебная записка</div>
                                    <div className="right-column">
                                        {
                                            requestCard.memo.documentFile && requestCard.memo.documentFile.fileName &&
                                            <p>
                                                <a onClick={() => RequestServices.downloadMemoDocument(
                                                    {
                                                        fileName: requestCard.memo.documentFile.fileName,
                                                        uid: requestCard.uid,
                                                    },
                                                )}
                                                // target={"_blank"} href="#"
                                                className="request-colored-link">
                                                    {requestCard.memo.documentFile.fileName}
                                                </a>
                                            </p>
                                        }
                                    </div>
                                </div>
                            )}
                        </div>

                        {step === 1 ?
                            (
                                <div className="buttons-wrapper">
                                    <button className="ui-u-button request-modal__button" disabled=""
                                        onClick={() => {
                                            setStep(0);

                                        }
                                        }>
                                        Назад
                                    </button>
                                    <button className="ui-u-button request-modal__button" disabled=""
                                        onClick={() => {
                                            // close();
                                            setStageModalWindow(testHOC);
                                        }}>
                                        направить
                                    </button>
                                </div>
                            ) : (
                                <div className="buttons-wrapper">
                                    <button
                                        onClick={() => {
                                            close();
                                            setStageModalWindow(null);

                                        }}
                                        className="ui-u-button request-modal__button">
                                        закрыть
                                    </button>
                                    {requestCard.memo ? null :
                                        <button className="ui-u-button request-modal__button"
                                            disabled={!selectedE.length}
                                            onClick={() => setStep(1)}>
                                            Далее
                                        </button>
                                    }

                                </div>
                            )
                        }
                    </>
            }

        </div>
    );
};

export default RecruitmentToWorkOnHolidaysContent;
